export default __webpack_public_path__ + "static/media/AngusMad.6765ea63.jpg";